import api from "../../utils/Api";
import {
  SAVE_PATIENT_PROFILE_REQUEST,
  SAVE_PATIENT_PROFILE_SUCCESS,
  SAVE_PATIENT_PROFILE_ERROR,
} from "./SavePatientProfileTypes";

export const savePatientProfileRequest = () => {
  return {
    type: SAVE_PATIENT_PROFILE_REQUEST,
  };
};

export const savePatientProfileSuccess = (savePatientProfile) => {
  return {
    type: SAVE_PATIENT_PROFILE_SUCCESS,
    payload: savePatientProfile,
  };
};

export const savePatientProfileFailure = (error) => {
  return {
    type: SAVE_PATIENT_PROFILE_ERROR,
    payload: error,
  };
};

export const savePatientProfile = (payload) => {

    const headers = {
        'Content-Type': "multipart/form-data",
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
  return async (dispatch) => {
    dispatch(savePatientProfileRequest());
    try {
        const response = await api.post("relatedparty/patientprofile/save", payload, {
            headers: headers,
          });
      const savePatientProfileData = response.data.data;
     // console.log("savePatientProfileData", savePatientProfileData)
      dispatch(savePatientProfileSuccess(savePatientProfileData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(savePatientProfileFailure(errorMsg));
    }
  };
};
